import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../../lib";
import { failureHash } from "./affiliate.static";
export class ApiEpBillingAffiliate {
}
ApiEpBillingAffiliate.retrieve = () => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/billing/v1/affiliate`,
    method: "GET",
});
ApiEpBillingAffiliate.update = (req) => apiRequest({
    body: req.body,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/billing/v1/affiliate`,
    method: "PUT",
}, failureHash);
ApiEpBillingAffiliate.updatePartial = (req) => apiRequest({
    body: req.body,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/billing/v1/affiliate`,
    method: "PATCH",
}, failureHash);
//# sourceMappingURL=affiliate.js.map